import GridContainer from "@insite/mobius/GridContainer";
import { css } from "styled-components";

(GridContainer as any).defaultProps = {
    css: css`
        margin: 0 auto;
    `,
};
